import { actions } from '@/modules/SuiviInterventionsPreventives/store/actions';
import { getters } from '@/modules/SuiviInterventionsPreventives/store/getters';
import { mutations } from '@/modules/SuiviInterventionsPreventives/store/mutations';
import { state } from '@/modules/SuiviInterventionsPreventives/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { SuiviInterventionPreventiveState } from './state';

const SuiviInterventionPreventiveModule: Module<SuiviInterventionPreventiveState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default SuiviInterventionPreventiveModule;
export type { SuiviInterventionPreventiveState };
